import { URL_PREFIX } from '@/constants'

export const getPartnerSlug = () => {
  const url = window.location.pathname

  if (url.startsWith(`/${URL_PREFIX}`)) {
    // eslint-disable-next-line no-useless-escape
    const urlRegex = /(?<prefix>[\w-]+)\/(?<partner>[\w-]+)/
    const urlGroups = url.match(urlRegex)?.groups
    const partnerSlug = urlGroups?.partner

    return partnerSlug
  }

  return undefined
}

export default getPartnerSlug
